<template>
  <div class="as-incident-list" v-if="incidents.data?.length">
    <div class="as-incident-list__head">
      <div class="as-head-current" v-if="incidents.match">
        <div class="as-match-time">
          {{ formatLocalTime(incidents.match.match_time, "DD/MM/YYYY h:mm") }}
        </div>
        <div class="as-match-status">
          {{ getLableTitle(incidents.match.status_id) }}
        </div>
      </div>
      <div class="as-head-scores-round" v-if="rounds">
        <div
          class="as-head-scores-round__items"
          v-for="(incident, key) in rounds"
          :key="key"
        >
          <div class="as-round-name">{{ getLableTitle(incident.set) }}</div>
          <div class="as-round-scores">
            <div
              class="as-round-scores__as-home"
              :class="{
                'as-win':
                  getScoresInMatch(incident.set)[0] >
                  getScoresInMatch(incident.set)[1],
              }"
            >
              {{ getScoresInMatch(incident.set)[0] }}
            </div>
            <div
              class="as-round-scores__as-away"
              :class="{
                'as-win':
                  getScoresInMatch(incident.set)[0] <
                  getScoresInMatch(incident.set)[1],
              }"
            >
              {{ getScoresInMatch(incident.set)[1] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="as-incident-list__body" v-if="rows">
      <div
        class="as-incident__item"
        v-for="(incident, index) in rows"
        :key="index"
      >
        <h3
          @click="changeActiveCollapse(index.toString())"
          :class="{
            'as-active': activeCollapse === index.toString(),
          }"
        >
          <span>
            {{ getLableIndex(incident.set) }}
            {{ getScoresInMatch(incident.set)[0] }} -
            {{ getScoresInMatch(incident.set)[1] }}
          </span>
          <ArrowDown fill="#4CF446" />
        </h3>
        <div
          v-if="incident.scores.length"
          v-for="(item, key) in incident.scores"
          :key="key"
          :class="`as-incident_row ${item._class}`"
          v-show="activeCollapse == index.toString()"
        >
          <div class="as__left">
            <IconBadminton />
          </div>
          <div class="as__right">
            <span :class="{'as-win': item._homeWin}">{{ item.home_score }}</span> - <span :class="{'as-win': !item._homeWin}">{{ item.away_score }}</span>
          </div>
          <div
            class="as__right"
            v-if="item._diffScore > 0"
          >
            <span
              class="as-diff-score"
              :class="{
                'as-win': (item._homeWin && item.home_score > item.away_score) || (!item._homeWin && item.away_score > item.home_score),
                'as-lose': (item._homeWin && item.home_score <= item.away_score) || (!item._homeWin && item.away_score <= item.home_score)
              }"
            >
              +{{ item._diffScore }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import NoData from "~src/components/NoData.vue";
import IconBadminton from "~src/components/icons/IconBadminton.vue";
import type {
  IIncidentData,
  IIncidentRealTime,
  IRealTime,
} from "~src/interfaces/badminton";
import MatchEnum from "~src/enums/badminton/MatchEnum";
import { formatLocalTime } from "~src/helpers/CommonHelper";
interface IProps {
  incidents: IIncidentRealTime;
}

const props = withDefaults(defineProps<IProps>(), {});
const activeCollapse = ref("0");

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};

const processIncidents = (incidents:IIncidentData[], reverse: boolean = false) => {
  return incidents
    .sort((a: IIncidentData, b: IIncidentData) => Number(a.set) - Number(b.set))
    .map((item: any) => {
      let _scores = item.scores;
      if (_scores) {
        _scores.map((score: IRealTime, index: number) => {
          let _class = "";
          let _homeWin = true;
          let _diffScore = 0;
          if (index) {
            if (
              score.home_score == _scores[index - 1].home_score &&
              score.away_score > _scores[index - 1].away_score
            ) {
              _class = "as-away";
              _homeWin = false;
            }
          } else {
            if (score.away_score > score.home_score) {
              _class = "as-away";
              _homeWin = false;
            }
          }
          score._class = _class;
          score._homeWin = _homeWin;
          score._diffScore = Math.abs(score.away_score - score.home_score);
        });
      }
      return {
        ...item,
        scores: _scores.slice().reverse(),
      };
    });
}

const rounds = computed(() => {
  const incidents = props.incidents.data;
  return processIncidents(incidents);
});

const rows = computed(() => {
  const incidents = props.incidents.data;
  return processIncidents(incidents, true).reverse();
});

const getLableTitle = (set: number | string) => {
  const text = MatchEnum.MATCH_STATUS_TEXT as { [key: string]: any };
  return text[set] ?? "FT";
};

const getLableIndex = (set: number | string, get_text = true) => {
  const text = {
    "51": 1,
    "52": 2,
    "53": 3,
    "54": 4,
    "55": 5,
  } as { [key: string]: any };

  if (get_text) {
    return text[set] ? `H${text[set]}` : "";
  } else {
    return text[set] ?? 0;
  }
};

const matchScores = computed(() => {
  return props.incidents.match?.scores ?? {};
});

const getScoresInMatch = (set: number | string) => {
  const index = getLableIndex(set, false);
  const value = matchScores.value[`p${index}`] || ["", ""];

  return value;
};
</script>

<script lang="ts">
export default {};
</script>
